import { Button } from '@/components/ui/button'
import { Volume2, VolumeX, Home } from 'lucide-react'
import UserAssinaturaButton from '@/features/signatures/components/button-ass-user'
import { FeedbackDialog } from '../feedback-dialog'
import { generatePDF } from '@/features/agreement/utils/pdf-util'
import RequestEditModal from '@/features/agreement/components/bnt-requestEdit'
import { MinutaContent } from '@/features/agreement/components/minutaContent'
import useMinutaUser from '@/features/agreement/components/useMinutaUser'

export default function MinutaUser() {
  const {
    agreementData,
    agreementError,
    editableHtml,
    fullStyledHtml,
    handleBack,
    handleUpdateAgreement,
    handleSave,
    handleSpeak,
    handleStop,
    historySuggestions,
    isDialogOpen,
    isSpeaking,
    message,
    selectedIcon,
    setIsDialogOpen,
    shouldShowLoading,
    signatureError,
    signatureStatus,
    user
  } = useMinutaUser()

  if (!user?.id) return <div>Erro: nenhum ID foi fornecido.</div>
  if (agreementError) return <div>Erro ao carregar o contrato: {agreementError.message}</div>
  if (signatureError) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <p className="text-lg font-semibold text-red-600 text-center">Erro ao verificar assinatura. Tente novamente.</p>
      </div>
    )
  }

  return (
    <div className="container mx-auto p-4 flex flex-col items-center w-full">
      <div className="w-full text-center mb-6">
        <h1 className="text-3xl md:text-3xl font-bold mb-6 text-gray-800">Contrato</h1>
        <div className="flex flex-wrap justify-center gap-2 md:gap-4">
          <Button onClick={isSpeaking ? handleStop : handleSpeak}>
            {isSpeaking ? <VolumeX className="mr-2 h-4 w-4" /> : <Volume2 className="mr-2 h-4 w-4" />}
            {isSpeaking ? 'Parar' : 'Ler em voz alta'}
          </Button>

          {signatureStatus?.data?.isModifica && <UserAssinaturaButton />}

          {!signatureStatus?.data?.isModifica &&
            (signatureStatus?.data?.isVerifed || agreementData?.status === 'PENDENTE') && (
              <Button onClick={() => void handleUpdateAgreement()}>Fechar Contrato</Button>
            )}

          <Button onClick={() => generatePDF(fullStyledHtml, selectedIcon)}>Baixar PDF</Button>

          {user && agreementData?.id && !agreementData?.isAssinado && <RequestEditModal idAgreement={agreementData.id} />}

          <Button onClick={handleBack} title="Voltar" className="fixed bottom-4 left-4 rounded-full w-12 h-12">
            <Home className="w-6 h-6" />
          </Button>
        </div>
      </div>

      <MinutaContent
        shouldShowLoading={shouldShowLoading}
        editableHtml={editableHtml}
        fullStyledHtml={fullStyledHtml}
        handleSave={handleSave}
        selectedIcon={selectedIcon}
        historySuggestions={historySuggestions}
      />
      <FeedbackDialog isOpen={isDialogOpen} onOpenChange={setIsDialogOpen} message={message} />
    </div>
  )
}
